import ContractInfo from '../pages/ContractInfo.svelte'; // 契約内容参照
import ContractChange from '../pages/ContractChange.svelte'; // 契約内容変更
import CustomerInfo from '../pages/CustomerInfo.svelte'; // 契約者情報参照
import CustomerChange from '../pages/CustomerChange.svelte'; // 契約者情報変更
import Call from '../pages/Call.svelte'; // 通話明細
import Billing from '../pages/Billing.svelte'; // 請求明細
import Login from '../pages/Login.svelte'; // ログイン
import ResetLoginInfo from '../pages/ResetLoginInfo.svelte'; // パスワード確認・変更（認証）
import ResetSettingPassword from '../pages/ResetSettingPassword.svelte'; // パスワード確認・変更
import ConfirmLoginInfo from '../pages/ConfirmLoginInfo.svelte'; // ログインID確認
import Top from '../pages/Top.svelte';
import SimExchangeDeliveryHistory from '../pages/SimExchangeDeliveryHistory.svelte'; // SIM交換履歴
import WithdrawalHikari01 from '../pages/withdrawal/WithdrawalHikari01.svelte';
import Invoice from '../pages/Invoice.svelte';
import ResetLoginInfoReminders from '../pages/ResetLoginInfoReminders.svelte'; // パスワード確認・変更（認証） リマインダーメールから
import Initial from '../pages/invitation/umobiled/Initial.svelte';
import Main from '../pages/invitation/umobiled/Main.svelte';
import Received from '../pages/invitation/umobiled/Received.svelte';
import PaymentResult from '../pages/invitation/umobiled/PaymentResult.svelte';
import MnpPortin from '../pages/invitation/umobiled/MnpPortin.svelte';
// [Note] 2021/06/30 一部ログイン情報から取得できるように対応。customer_idやcontract_idは存在しないため、考慮が必要
export const routes = {
    '/': Top,
    '/login': Login,
    '/reset/login-info/': ResetLoginInfo,
    '/reset/login-info/reminders/': ResetLoginInfoReminders,
    '/reset/setting-password/:token': ResetSettingPassword,
    '/confirm/login-info/': ConfirmLoginInfo,
    '/contract/info/': ContractInfo,
    '/contract/change/': ContractChange,
    '/customer/info/': CustomerInfo,
    '/customer/change/': CustomerChange,
    '/call/': Call,
    '/billing/': Billing,
    '/sim-exchange-delivery/history/': SimExchangeDeliveryHistory,
    '/withdrawal/hikari01/': WithdrawalHikari01,
    '/invoice/': Invoice,
    '/invitation/umobiled/initial/': Initial,
    '/invitation/umobiled/main/:token': Main,
    '/invitation/umobiled/received/:token/:code/': Received,
    '/invitation/umobiled/payment-result/?': PaymentResult,
    '/invitation/umobiled/mnp-portin/': MnpPortin
};
